import JuristicFeatureLayout from "./JuristicFeatureLayout";
import JuristicFeatureListPage from "./pages/JuristicFeatureListPage";
import JuristicFeatureEditor from "./pages/JuristicFeatureEditor";

export const juristicFeatureRoutes = {
  path: "juristic-feature",
  component: JuristicFeatureLayout,
  children: [
    {
      name: "JuristicFeatureListPage",
      component: JuristicFeatureListPage,
      path: ""
    },
    {
      name: "JuristicFeatureEditor",
      path: ":id",
      component: JuristicFeatureEditor
    },
  ]
};



// WEBPACK FOOTER //
// ./src/features/juristic-feature/routes.js